import { useEffect, useRef, useState, type ReactNode } from 'react'

/**
 * The second, separate step before live prices leave: its own button, never focused, disabled until the
 * acknowledgement is ticked, so a double-click or repeated Enter on the first step cannot reach it.
 */
export function ApplyConfirmation({
  testId,
  acknowledgement,
  busy,
  onConfirm,
  onCancel,
  children,
}: {
  testId: string
  acknowledgement: string
  busy: boolean
  onConfirm: () => void
  onCancel: () => void
  children: ReactNode
}) {
  const [acknowledged, setAcknowledged] = useState(false)
  const checkbox = useRef<HTMLInputElement | null>(null)

  useEffect(() => {
    checkbox.current?.focus()
  }, [])

  return (
    <div data-testid={testId} role="group" aria-label="Подтверждение применения" className="w-full space-y-2 rounded-md border border-gold/50 bg-gold/10 p-3 text-left text-sm text-ink-2">
      <p role="alert">{children}</p>
      <label className="flex items-center gap-2 font-medium text-ink">
        <input ref={checkbox} type="checkbox" checked={acknowledged} disabled={busy} onChange={(event) => setAcknowledged(event.target.checked)} />
        {acknowledgement}
      </label>
      <div className="flex flex-wrap justify-end gap-2">
        <button type="button" className="btn btn-ghost" disabled={busy} onClick={onCancel}>Назад</button>
        <button type="button" className="btn btn-primary" disabled={!acknowledged || busy} onClick={onConfirm}>Подтвердить применение</button>
      </div>
    </div>
  )
}
